<template>
  <div
    class="collection-filter"
    :class="customClass"
  >
    <template v-if="filters.length > 0">
      <div
        v-for="(filter, index) of filters"
        :key="`quicksearch-filter-${index}`"
        class="collection-filter__options"
      >
        <h2
          class="text-heading-2xs"
          v-text="filterLabel(filter.label)"
        />
        <splide
          v-if="secondaryCollection"
          :has-track="false"
          :options="splideConfig"
        >
          <splide-track>
            <splide-slide
              v-for="(option, i) of filter.options"
              :key="`filter-${i}`"
              class="collection-filter__option"
            >
              <btn
                class="collection-filter__btn"
                :class="{'selected': option.selected}"
                modifiers="secondary reversed fill"
                show-icon
                :label="getLabel(filter.key, option.name)"
                @click="updateFilter(filter.key, option.value)"
              >
                <template #icon>
                  <icon-minus v-if="option.selected" />
                  <icon-plus v-else />
                </template>
              </btn>
            </splide-slide>
          </splide-track>
        </splide>

        <div
          v-for="(option, i) of filter.options"
          v-else
          :key="`quicksearch-filter-options-${i}`"
          class="collection-filter__option"
        >
          <btn
            class="collection-filter__btn"
            :class="{'selected': option.selected}"
            modifiers="secondary reversed fill"
            show-icon
            :label="getLabel(filter.key, option.name)"
            @click="updateFilter(filter.key, option.value)"
          >
            <template #icon>
              <icon-minus v-if="option.selected" />
              <icon-plus v-else />
            </template>
          </btn>
        </div>
      </div>
    </template>

    <div
      v-else
      class="collection-filter__options"
    >
      <p
        class="text-heading-2xs"
        v-text="$string('collection.filter.no_filter')"
      />
    </div>
  </div>
</template>

<script>

import Btn from '~global/btn/btn'
import IconPlus from '~icons/directional-navigation/plus.svg'
import IconMinus from '~icons/directional-navigation/minus.svg'
import { Splide, SplideSlide, SplideTrack } from '@splidejs/vue-splide'

/**
 * Vue: Collection filter (collection-filter)
 * -----------------------------------------------------------------------------
 * Filter bar to appear on PLPs and Search page.
 *
 */
export default {
  name: 'CollectionFilter',
  components: {
    Btn,
    IconMinus,
    IconPlus,
    Splide,
    SplideSlide,
    SplideTrack,
  },

  props: {
    filters: {
      type: Array,
      default: () => [],
    },
    customClass: {
      type: String,
      default: '',
    },
    secondaryCollection: {
      type: Boolean,
      default: false,
    },
  },

  emits: {
    'update-filters': () => true,
  },

  data() {
    return {
      splideConfig: {
        arrows: false,
        autoWidth: true,
        drag: true,
        gap: 'var(--spacing-m)',
        pagination: false,
      },
    }
  },

  mounted() {
    // Not empty
  },

  methods: {
    updateFilter(key, value) {
      this.$emit('update-filters', key, value)
    },

    getLabel(key, value) {
      if (key !== 'sawmill_model' || key !== 'sawmill_model_new') {
        return value
      }

      return value.split('|').join(' | ')
    },

    filterLabel(label) {
      return `${this.$string('collection.filter.label')} ${label}`
    },
  },
}
</script>

<style lang="scss">
@import './collection-filter';
</style>
